
export const getRiskLabel = (level: number) => {
  switch (level) {
    case 1:
      return { text: "Low Risk", color: "text-green-500" };
    case 2:
      return { text: "Medium Risk", color: "text-orange-500" };
    case 3:
      return { text: "High Risk", color: "text-red-500" };
    default:
      return { text: "Unknown", color: "text-gray-500" };
  }
};

export const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
};

export const getExchangeLogo = (exchange: string) => {
  switch (exchange) {
    case "OKX":
      return "/lovable-uploads/9374987f-70d0-4ef3-a74d-deada4d71a29.png";
    case "Bybit":
      return "/lovable-uploads/f8e24343-7970-4066-8449-f3d42e90e07e.png";
    case "Bitget":
      return "/lovable-uploads/c82b7495-c4d9-462e-90d9-bb62f24a1e7d.png";
    case "Phemex":
      return "/lovable-uploads/65150818-855b-40d2-b7f4-d5469fcee9b2.png";
    default:
      return "";
  }
};

export const mapRiskWillingnessToLevel = (willingness: string): string[] => {
  if (!willingness) return [];

  const riskValue = parseInt(willingness);
  if (riskValue >= 1 && riskValue <= 3) return ["1"];
  if (riskValue >= 4 && riskValue <= 7) return ["2"];
  if (riskValue >= 8 && riskValue <= 10) return ["3"];
  return [];
};

export const determineExchange = (preferences: string[] | null): string[] => {
  if (!preferences || preferences.length === 0) return [];
  
  const exchangeMap: { [key: string]: boolean } = {
    "okx": false,
    "bybit": false,
    "bitget": false,
    "phemex": false
  };

  preferences.forEach(pref => {
    const lowerPref = pref.toLowerCase();
    if (lowerPref.includes("okx")) exchangeMap.okx = true;
    if (lowerPref.includes("bybit")) exchangeMap.bybit = true;
    if (lowerPref.includes("bitget")) exchangeMap.bitget = true;
    if (lowerPref.includes("phemex")) exchangeMap.phemex = true;
  });

  return Object.entries(exchangeMap)
    .filter(([_, isSelected]) => isSelected)
    .map(([exchange]) => exchange.toUpperCase());
};
